//Libraries
import { FC } from "react";
import { useLocation, useNavigate } from "react-router-dom";

//Typing
import { ISummary } from "src/types";
import { APP_URLS } from "src/constants";

//Components
import { OpsForm } from "./operations/opsForm";
import { Loader } from "src/generic/component";

/**
 * This component is only responsible for extracting
 * the summary data from the navigation and instantiating
 * the OpsForm.  This allows us to use the OpsForm in modals
 * or other implementations without having to re-write the subform
 */
export const OperationFormPage: FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as any;
  const summary = state?.summary as ISummary;
  const type = state?.type;

  if (summary) {
    return (
      <OpsForm
        onComplete={(summary) => {
          type === 'di' && navigate(APP_URLS.DIHOME, {state: { type: 'di' }});
          type === 'ai' && navigate(APP_URLS.HOME, {state: { type: 'ai' }});
        }}
        onClose={() => {
          type === 'di' && navigate(APP_URLS.DIHOME, {state: { type: 'di' }});
          type === 'ai' && navigate(APP_URLS.HOME, {state: { type: 'ai' }});
        }}
        summary={summary}
      ></OpsForm>
    );
  } else {
    return <Loader></Loader>;
  }
};
